<template>
  <div class="phone-field">
    <div class="label">
      手机号
    </div>
    <div class="value">
      <input @input="onInput" type="number" pattern="\d*" oninput="value=value.replace(/[^\d]/g,'')" v-model="phone" placeholder="请输入手机号" />
    </div>
  </div>
</template>
<script>
export default {
  name: "phoneField",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      phone: '',
    };
  },
  methods: {
    onInput(val) {
      if (val.target.value.length > 11) {
        this.phone = val.target.value.slice(0, 11);
      }
      this.$emit("input", this.phone);
    },
  },
  watch: {
    value(newVal) {
      this.phone = newVal;
    },
  },
};
</script>
<style scoped lang="scss">
.phone-field {
  display: flex;
  margin-top: 20px;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  .value {
    display: flex;
    align-items: center;
    padding: 10px 0px;
    border-bottom: 1px solid rgba(51,51,51,0.1);
    input {
      border: none;
      outline: none;
      background: transparent;
      &::placeholder {
        color: rgba(51,51,51,0.4);
      }
    }
  }
}
</style>
